export async function VispsicologicasCreate( 
    vispsicResp,
    vispsicFecha,
    vispsicHora,
    vispsicObs,
    tratamientoId,
    pacienteId ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-vispsic-${vispsicFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-vispsic-${vispsicFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            vispsicResp: vispsicResp,
            metaFecha: vispsicFecha,
            metaPaciente: pacienteId,
            vispsicHora: vispsicHora,
            vispsicObs: vispsicObs,
        }
        
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/vispsicolog', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}